<template>
  <div class="mine-content">
    <div class="mine-header"><span @click="util.goblack()" class="back"><img
          src="@/assets/images/base/icon_righ_g.png" /></span>Recharge</div>
    <div class="second-pard">
      <div class="xzje" style="font-weight:bold;">Select a fast amount</div>
      <ul>
        <li><button @click="setMoney(1000)" :class="money == 1000 ? 'on' : ''">1000</button></li>
        <li><button @click="setMoney(3000)" :class="money == 3000 ? 'on' : ''">3000</button></li>
        <li><button @click="setMoney(5000)" :class="money == 5000 ? 'on' : ''">5000</button></li>
        <li><button @click="setMoney(7000)" :class="money == 7000 ? 'on' : ''">7000</button></li>
        <li><button @click="setMoney(10000)" :class="money == 10000 ? 'on' : ''">10000</button></li>
        <li><button @click="setMoney(15000)" :class="money == 15000 ? 'on' : ''">15000</button></li>
        <li><button @click="setMoney(30000)" :class="money == 30000 ? 'on' : ''">30000</button></li>
        <li><button @click="setMoney(50000)" :class="money == 50000 ? 'on' : ''">50000</button></li>
      </ul>
      <div class="xzje" style="font-weight:bold;">Enter recharge amount</div>
      <input class="money" v-model="money" />
      <div class="xzje" style="font-weight:bold;">Select recharge channel</div>
      <input class="money" readonly v-model="channel" @click="showChannel = true" />
      <van-picker class="van_picker" toolbar-position="top" v-show="showChannel" :columns="channels" :default-index="0"
        show-toolbar title="Please select Recharge channel" @cancel="onCancel" @confirm="onConfirm"
        confirm-button-text="OK" cancel-button-text="Cancel" />
      <div v-show="!showChannel">
        <div class="xzje" style="color:#f6543e;font-weight:bold;">Recharge prompt message</div>
        <textarea class="money errerinfo" readonly v-model="errorInfo"></textarea>
        <button class="btn-submit" v-show="!showloding" @click="submitbtn">Submit</button>
        <button class="btn-submit" v-show="showloding">Submit</button>
      </div>
    </div>
    <div class="box_shadow">
      <div class="title_box">Hello, Please contact teacher to get the latest channels for recharging. Thank you for your
        support and trust. Please return to the previous page.</div>
    </div>
    <van-loading v-show="showloding" size="50px" color="#1989fa" vertical />
  </div>
</template>
<script>
import Vue from "vue";
import { Loading } from "vant";
Vue.use(Loading);
import { Picker } from 'vant';
Vue.use(Picker);
export default {
  data() {
    return {
      showloding: false,
      money: 5000,
      showChannel: false,
      channel: "",
      channelId: 0,
      channels: [],
      channelIdList: [],
      errorInfo: "",
    };
  },
  methods: {
    submitbtn() {
      let re = /[^\d]/g;
      if (!this.money) {
        this.errorInfo = "Amount cannot be empty";
      } else if (re.test(this.money)) {
        this.errorInfo = "Amount can only be a whole number";
      } else if (this.money < 100) {
        this.errorInfo = "Amount cannot be less than 100";
      } else if (!this.showloding) {
        this.errorInfo = "Recharge submission in progress..";
        this.saveRecharge();
      }
    },
    saveRecharge() {
      let params = {
        rechargeMoney: this.money,
        channelId: this.channelId
      };
      this.util.setDnValueUser(params);
      this.axios.post(this.api.api_recharge, this.util.encodeSearchParams(params)).then(res => {
        this.showloding = false;
        if (res.data.code == 0) {
          this.errorInfo = "Start going to the Recharge page..";
          window.location.href = res.data.data.paymentUrl;
        } else {
          this.errorInfo = res.data.message;
        }
      })
        .catch(() => {
          this.showloding = false;
          this.errorInfo = "Recharge failed";
        });
    },
    setMoney(money) {
      this.money = money;
    },
    onCancel() {
      this.showChannel = false;
    },
    onConfirm(value, index) {
      this.channelId = this.channelIdList[index];
      this.channel = value;
      this.showChannel = false;
    },
    findConfig() {
      this.showloding = true;
      let params = {}
      this.util.setDnValueToken(params);
      this.axios.get(this.api.api_getRechargeConfig, { params: params }).then((res) => {
        this.showloding = false;
        if (res.data.code == 0) {
          this.channelIdList = [];
          this.channels = [];
          res.data.data.forEach(item => {
            let id = item.id < 10 ? "0" + item.id : item.id;
            if (item.status == 1) {
              this.channels.push("Channel:" + id + "(" + item.min_charge + "-" + item.max_charge + ")");
              this.channelIdList.push(item.id);
            }
          })
          this.channel = this.channels[0];
          this.channelId = this.channelIdList[0];
        } else {
          this.util.checkToken(res.data.message);
        }
      })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  activated() {
    this.errorInfo = "";
  },
  mounted() {
    this.findConfig();
  }
};
</script>
<style lang="scss" scoped>
.mine-content {
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  font-size: 0.34rem;
  background: rgb(235, 235, 235);
  color: black;
  width: 100%;
  height: 100%;

  .box_shadow {
    width: 100%;
    position: fixed;
    top: 40px;
    left: 0;
    bottom: 0;
    background: rgba($color: #000000, $alpha: 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1;

    .title_box {
      width: 80%;
      padding: 20px;
      font-size: #333;
      background: #fff;
      border-radius: 10px;
      margin-bottom: 40px;
      font-size: 0.32rem;
    }
  }

  .van_picker {
    background-color: rgb(164, 194, 219);
    width: 100%;
    border-radius: 10px/10px;
  }

  .mine-header {
    font-weight: bold;
    height: 1rem;
    display: grid;
    grid-template-columns: 30% 1fr 30%;
    align-items: center;
    text-align: center;

    .back {
      cursor: pointer;

      img {
        display: block;
        margin-left: 5%;
        width: 0.5rem;
        transform: rotate(180deg);
      }
    }
  }

  .second-pard {
    width: 96%;
    background: white;
    margin: auto;
    padding: 5px 5px;
    border-radius: 10px/10px;

    .xzje {
      font-size: 0.32rem;
      padding-left: 5px;
      color: black;
    }

    ul {
      cursor: pointer;
      display: grid;
      grid-template-columns: 25% 25% 25% 25%;
      justify-items: center;

      // padding: 10px 0;
      button {
        border-radius: 5px/5px;
        margin: 5px auto;
        padding: 4px 0;
        width: 2.2rem;
        color: black;
        border: 1px solid rgb(232, 234, 237);
      }

      .on,
      button:hover {
        background: #628808;
        color: white;
      }
    }

    .money {
      width: 98.5%;
      height: 1rem;
      border-radius: 5px/5px;
      color: black;
      border: 1px solid rgb(232, 234, 237);
      margin: 5px 2px;
      padding: 0 10px;
    }

    .errerinfo {
      height: 2rem;
      padding-top: 4px;
      color: #f6543e;
      font-weight: bold;
      background-color: rgb(228, 222, 222);
      text-align: left;
      vertical-align: auto;
    }

    .btn-submit {
      margin: 5px auto;
      width: 100%;
      border-radius: 4px;
      font-size: 0.34rem;
      height: 0.85rem;
      background: #628808;
      color: white;
    }

    .btn-submit:hover {
      background: #628808;
    }
  }
}
</style>